<template>
  <div>
    <loadingCube v-if="!loading_order || !notEmptyObject(order)" :loadingMessage="'COPY ORDER'"></loadingCube>
    <div v-else>
      <h2 class="font-weight-bold bp_color mb-0">COPYING FROM {{ get_order_ref() }}</h2>
      <h5>{{ get_company_name() }}</h5>

      <!-- BASIC ORDER INFORMATION -->
      <div class="card record geniusCard mt-3 mb-3">
        <h4 class="mb-0">BASIC ORDER INFORMATION</h4>
        <hr class="mt-1">
        <div class="row record_card_body">
          <div class="col-lg-3 col-md-6">
            <!-- Original Order Date -->
            <div class="form-group">
              <label class="form-label" for="original_order_date">Original Order Date</label>
              <p id="original_order_date">{{ get_date_of_order() }}</p>
            </div>
            <!-- Original Order Type -->
            <div class="form-group">
              <label class="form-label" for="original_order_type">Original Order Type</label>
              <p id="original_order_type">{{ order.order_type }}</p>
            </div>
          </div>
          <!-- Original Order Consultant -->
          <div class="col-lg-9 col-md-6">
            <div class="row">
              <div class="col-xl-4">
                <label class="form-label" for="original_order_consultant">Original Order Consultant</label>
                <p id="original_order_consultant">{{ get_order_consultant() }}</p>
              </div>
              <ValidationProvider rules="required|oneOf:Keep,Change" v-slot="{errors, classes}" name="Order Consultant" tag="div"
                                  class="form-group col-xl-8" v-if="show_new_consultant">
                <div class="pretty p-icon p-curve">
                  <input type="radio" name="new_order_consultant" value="Keep" v-model="new_order_consultant">
                  <div class="state p-success-o"><i class="icon fa fa-check"></i><label>Keep consultant the same</label></div>
                </div>
                <div class="pretty p-icon p-curve">
                  <input type="radio" name="new_order_consultant" value="Change" v-model="new_order_consultant">
                  <div class="state p-warning-o"><i class="icon fa fa-check"></i><label>Change consultant to myself</label></div>
                </div>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="row record_card_body">
          <!-- GM Solution -->
          <div class="col-lg-3 col-md-6 form-group" v-if="is_payroll_crm">
            <label class="form-label" for="order_gm_solution">GM Solution</label>
            <p id="order_gm_solution">{{ get_gm_solution() }}</p>
          </div>
          <!-- GM Project Manager -->
          <!--              TODO -- if already 'you' pre select keep consultant the same-->
          <div class="col-lg-9 col-md-6" v-if="is_payroll_crm && is_gm_project_managed_solution">
            <div class="row">
              <div class="col-xl-4">
                <label class="form-label" for="order_gm_project_manager">GM Project Manger</label>
                <p id="order_gm_project_manager">{{ get_gm_project_manager() }}</p>
              </div>
              <ValidationProvider rules="required|oneOf:Keep,Change" v-slot="{errors, classes}" name="Order Project Manager" tag="div"
                                  class="form-group col-xl-8" v-if="show_new_project_manager">
                <div class="pretty p-icon p-curve">
                  <input type="radio" name="new_project_manager" value="Keep" v-model="new_project_manager">
                  <div class="state p-success-o"><i class="icon fa fa-check"></i><label>Keep project manager the same</label></div>
                </div>
                <div class="pretty p-icon p-curve">
                  <input type="radio" name="new_project_manager" value="Change" v-model="new_project_manager">
                  <div class="state p-warning-o"><i class="icon fa fa-check"></i><label>Change project manager to myself</label></div>
                </div>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>

      <!-- ORDER LOCATIONS -->
      <div class="card record geniusCard mb-3">
        <h4 class="mb-0">ORDER LOCATIONS</h4>
        <hr class="mt-1">
        <div class="row record_card_body">
          <ValidationProvider rules="required" v-slot="{errors}" name="Order Locations" tag="div" class="col-12 form-group">
            <p class="pt-0 mb-2">Please select from the below the locations that you wish to copy into the new order:</p>
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12" v-for="location in order_locations">
                <div class="pretty p-icon p-curve">
                  <input type="checkbox" :value="location" :name="location" v-model="new_locations"/>
                  <div class="state"><i class="icon fa fa-check"></i><label>{{ location }}</label></div>
                </div>
              </div>
            </div>
            <div v-if="errors[0]" class="vvERROR">You must select at least one location to copy</div>
          </ValidationProvider>
          <div class="col-12 mt-3" v-if="new_locations.length > 1">
            <button class="btn orcaBtn sm_btn mr-2 mb-2" :class="[order_locations.length === new_locations.length ? 'disabled' : '']"
                    :disabled="order_locations.length === new_locations.length" @click.prevent="select_all_locations">Select All
            </button>
            <button class="btn orcaBtn grey_bg sm_btn mr-2 mb-2" :class="[new_locations.length === 0 ? 'disabled' : '']"
                    :disabled="new_locations.length === 0" @click.prevent="clear_locations">Clear Selection
            </button>
          </div>
        </div>
      </div>
      <!-- BUTTONS TO COPY JOB TITLES/RATES --- COPY JOB -->
      <div class="row" v-if="!show_copy_job_titles_rates">
        <div class="col-6">
          <button class="btn orcaBtn indigoBtn" @click.prevent="copy_job_titles_rates">Copy Job Titles / Rates</button>
        </div>
        <div class="col-6">
          <button class="btn orcaBtn" @click.prevent="copy_order">Copy Order</button>
        </div>
      </div>
      <!-- ORDER POSITIONS & RATES -->
      <div class="card record geniusCard mb-3" v-if="show_copy_job_titles_rates">
        <h4 class="mb-0">ORDER POSITIONS & RATES</h4>
        <hr class="mt-1">
        <div class="row record_card_body">
          <!-- Job Titles -->
          <ValidationProvider rules="required" v-slot="{errors}" name="Order Job Titles" tag="div" class="col-md-3 form-group">
            <h5 class="bp_color text-uppercase">Job Titles</h5>
            <p class="pt-0 mb-2">Select from the below the Job Titles that you wish to copy into the new order:</p>
            <div class="row">
              <div class="col-12" v-for="job_title in order_job_titles">
                <div class="pretty p-icon p-curve">
                  <input type="checkbox" :value="job_title" :name="job_title" v-model="new_job_titles"/>
                  <div class="state"><i class="icon fa fa-check"></i><label>{{ job_title }}</label></div>
                </div>
              </div>
            </div>
            <div v-if="errors[0]" class="vvERROR">You must select at least one job title to copy</div>
          </ValidationProvider>

          <!-- Rates -->
          <div class="col-md-9" v-if="Object.keys(order_rates).length > 0">
            <h5 class="bp_color text-uppercase">Rates</h5>
            <p class="pt-0 mb-2">Select from the below for each Job Title the Rates that you wish to copy into the new order:</p>

            <div class="row">
              <div class="col-12" v-for="(rates, job_title) in order_rates">
                <h5 class="font-weight-bold text-uppercase mb-0 mt-1">{{ job_title }}</h5>

                <div class="row">
                  <ValidationProvider rules="" v-slot="{errors}" name="Order Rates" tag="div" class="col-12 form-group">
                    <div class="row">
                      <div class="col-lg-4 col-sm-6 col-12" v-for="rate in rates">
                        <div class="pretty p-icon p-curve">
                          <input type="checkbox" :value="rate_checkbox_value_name(rate)" :name="rate_checkbox_value_name(rate)" v-model="new_rates[job_title]"/>
                          <div class="state">
                            <i class="icon fa fa-check"></i>
                            <label>
                              <strong class="rate_label">Rate:</strong> <span class="rate_field bp_color">{{ rate.pay_amount | currency }}</span><br>
                              <strong class="rate_label">Rate Type:</strong> <span class="rate_field">{{ rate.rate_type }}</span><br>
                              <strong class="rate_label">Pay Type:</strong> <span class="rate_field">{{ rate.pay_type }}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">You must select at least one job title to copy</div>
                  </ValidationProvider>
                </div>

                <div class="row" v-if="order_rates[job_title].length > 1">
                  <div class="col-12 mb-2">
                    <button class="btn orcaBtn sm_btn mr-2 mb-2" :class="[new_rates[job_title].length === order_rates[job_title].length ? 'disabled' : '']"
                            :disabled="new_rates[job_title].length === order_rates[job_title].length" @click.prevent="select_all_rates(job_title)">Select All
                    </button>
                    <button class="btn orcaBtn grey_bg sm_btn mr-2 mb-2" :class="[new_rates[job_title].length === 0 ? 'disabled' : '']"
                            :disabled="new_rates[job_title].length === 0" @click.prevent="clear_all_rates(job_title)">Clear Selection
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="show_copy_job_titles_rates">
        <div class="col-6">
          <button class="btn orcaBtn grey_bg" @click.prevent="cancel_copy_job_titles_rates">Cancel Copy Job Titles / Rates</button>
        </div>
        <div class="col-6">
          <button class="btn orcaBtn" @click.prevent="copy_order">Copy Order</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";

export default {
  name: "copy_order",
  components: {loadingCube},
  data() {
    return {
      loading_order: false,
      order_job: {},
      order_job_ids: [],
      order: {},

      order_locations: [],
      new_locations: [],
      found_locations: [],

      order_job_titles: [],
      new_job_titles: [],

      order_rates: {},
      new_rates: {},

      show_new_consultant: true,
      new_order_consultant: "Keep",
      show_new_project_manager: true,
      new_project_manager: "Keep",

      show_copy_job_titles_rates: false,
    }
  },
  beforeMount() {
    this.get_order();
  },
  computed: {
    is_payroll_crm() {
      // return if orca is currently genius or not
      return this.crmType === 'payroll'
    },
    is_gm_project_managed_solution() {
      // return if the order is a Project Managed type
      return this.order.order_gm_solution === 'Project Managed Labour Solutions'
    },
  },
  methods: {
    get_order() {
      axios.get(this.crmApiPath + 'order/job/' + this.$store.state.orders.copy_order_job_id).then(order_job => {
        this.order_job = order_job.data;

        axios.get(this.crmApiPath + 'order/whole_order/job/' + this.$store.state.orders.copy_order_job_id).then(order => {
          this.order = order.data.order;
          this.order_locations = order.data.order_locations;
          this.order_job_titles = order.data.order_job_titles;
          this.order_job_ids = order.data.order_job_ids;

          this.new_locations.push(order_job.data.rel_order_location.job_address_full)

          this.loading_order = true

          if (order.data.order.consultant.id === this.$store.state.auth.me.id) {
            this.show_new_consultant = false;
          }
          if (this.is_payroll_crm && this.is_gm_project_managed_solution) {
            if (this.order.gm_project_manager_id === this.$store.state.auth.me.id) {
              this.show_new_project_manager = false;
            }
          }
        });
      });
    },

    /**
     * Locations
     */
    select_all_locations() {
      // if all locations are selected set the new_locations (to be copied locations)
      // to the value of all locations for the order being copied
      this.new_locations = this.order_locations;
    },
    clear_locations() {
      // reset the new_locations (to be copied locations) if clear selection button is clicked for locations
      this.new_locations = [];
    },
    /**
     * Basic Order Information GETTERS
     */
    get_order_ref() {
      return this.order_job.order_ref
    },
    get_company_name() {
      return this.order.company.company_name
    },
    get_date_of_order() {
      return this.$options.filters.formatDate(this.order.date_of_order)
    },
    get_order_consultant() {
      return this.order.consultant.first_name + ' ' + this.order.consultant.surname
    },
    get_gm_solution() {
      return this.order.order_gm_solution
    },
    get_gm_project_manager() {
      return this.order.project_manager.first_name + ' ' + this.order.project_manager.surname
    },
    /**
     * Copy / Cancel copy Job titles as rates
     */
    copy_job_titles_rates() {
      // if copying job titles and rates then set variable to show front end
      this.show_copy_job_titles_rates = true
    },
    cancel_copy_job_titles_rates() {
      // if cancelling the copy of job titles and rates then set variable to hide front end
      this.show_copy_job_titles_rates = false
      // reset job titles and rates (to be copied)
      this.new_job_titles = [];
      this.new_rates = {}
    },
    /**
     * Rates
     */
    rate_checkbox_value_name(rate) {
      return rate.pay_amount + '_' + rate.rate_type + '_' + rate.pay_type
          + '_' + rate.admin_fee_type.replace(' ', '-') + '_' + rate.admin_fee_amount + '_' + rate.retention_percentage
    },
    select_all_rates(rate_job_title_index) {
      // loop through all rates for the order being copied for the job title in question
      this.order_rates[rate_job_title_index].forEach(rate => {
        // set value for checkboxes to information from the rate
        let value = rate.pay_amount + '_' + rate.rate_type + '_' + rate.pay_type;
        // check if there are any selected rates already, add all other rates as selected
        if (!(this.new_rates[rate_job_title_index].includes(value))) {
          this.new_rates[rate_job_title_index].push(
              this.rate_checkbox_value_name(rate)
          )
        }
      });
    },
    clear_all_rates(rate_job_title_index) {
      // clear all selected rates for a specific job title to be copied
      this.new_rates[rate_job_title_index] = []
    },
    /**
     * Function to copy the order
     */
    copy_order() {
      this.$store.commit('RESET_ORDER_STEPS');
      // show copying overlay

      this.populate_basic_info().then(() => {
        this.populate_locations().then(() => {
          // Check if copying job titles and rates as well
          if (this.show_copy_job_titles_rates) {
            this.populate_positions_rates()
          }
          this.populate_timesheet_auth_and_accounts()
          //this.populate_compliance_terms()
          this.$nextTick(() => {
            this.$tabs.close({
              path: this.$router.currentRoute.fullPath,
              to: '/orders/create'
            });
            // this.$router.push('/orders/create');
            this.$tabs.refresh('/orders/create', true)
          });
        })
      });
      // open create order with pre-loaded info
      // close this template
    },

    /**
     * basic order to store
     */
    populate_basic_info() {
      return new Promise(resolve => {
        // check if keeping consultant the same
        let basic_info_consultant = this.$store.state.auth.me;
        if (this.new_order_consultant === 'Keep') {
          basic_info_consultant = this.order.consultant
        }
        // set order type by finding object with value of orders type being copied
        let basic_info_type = null;
        if (this.crmType === 'payroll') {
          basic_info_type = this.$store.state.crm_options.payroll_order_type.find(t => t.value === this.order.order_type);
        }
        else if (this.crmType === 'recruitment') {
          basic_info_type = this.$store.state.crm_options.recruitment_order_type.find(t => t.value === this.order.order_type);
        }
        // set payroll solution type from order being copied
        let  basic_info_payroll_solution = this.$store.state.crm_options.payroll_client_solution.find(pcs => pcs.value === this.order.order_gm_solution);

        // if payroll crm and Project Managed solution
        let basic_info_project_manager = null;
        if (this.order.order_gm_solution === "Project Managed Labour Solutions") {
          basic_info_project_manager = this.$store.state.auth.me;
          // check if keeping the project manager the same
          if (this.new_project_manager === 'Keep') {
            basic_info_project_manager = this.order.project_manager
          }
        }
        /**
         * Instantiate the object to be stored for basic info
         */
        let basic_info = {
          date_of_order: this.$moment.utc().format('YYYY-MM-DD'),
          consultant: basic_info_consultant,
          company: {
            company_name: this.order.company.company_name,
            id: this.order.company.id
          },
          type: basic_info_type,
          status: 'Live',
          payroll_solution: basic_info_payroll_solution,
          project_manager: basic_info_project_manager,
          job_contact: this.order.job_contact
        }
        // commit copied order basic information to the vuex store
        this.$store.commit('SAVE_BASIC_INFO_COMPLETED', basic_info);
        resolve();
      })

    },
    /**
     * job locations to store
     */
    populate_locations() {
      return new Promise(resolve => {
        // Instantiate locations object
        let locations = {
          number_of_sites: this.new_locations.length,
          site: [{}],
        };
        // axios call to get distinct job location(s) from full record(s)
        axios.get(this.crmApiPath + 'order/whole_order/location', {
          params: {
            order_job_ids: this.order_job_ids,
            job_addresses: this.new_locations
          }
        }).then(addresses => {
          // loop through each address returned and add to locations object
          addresses.data.forEach(address => {
            locations.site.push({
              short_site_name: address.short_site_name,
              address: {
                address_building: address.job_address_building,
                address_street: address.job_address_street,
                address_locality: address.job_address_locality,
                address_city_town: address.job_address_city_town,
                address_county: address.job_address_county,
                address_postcode: address.job_address_postcode
              },
              site_main_contractor: address.site_main_contractor,
              site_build_type: null, // do not need info
              site_vat_treatment: this.$store.state.crm_options.vat_percentage.find(vp => vp.value === address.site_vat_treatment + '%'),
              reverse_charge: address.reverse_charge ? true : false,
              geoTechEnabled: this.order_job.geotech_enabled ? true : false,
              rams: this.order_job.order_declarations
            })
          })

          // commit copied order locations to the vuex store
          this.$store.commit('SAVE_JOB_LOCATIONS_COMPLETED', locations);
          this.found_locations = locations
          resolve();
        })

      })
    },
    /**
     * Positions and Rates to store
     */
    populate_positions_rates() {
      // Instantiate positions_rates object
      let positions_rates = {
        number_of_positions: this.new_job_titles.length,
        position: [{}]
      };
      this.new_job_titles.forEach(job_title => {
        let found_order_job_by_job_title = this.order.rel_order_jobs.find(order_job => order_job.rel_order_position.job_title === job_title)
        let position = {
          sector: this.get_sector(found_order_job_by_job_title.rel_order_position.sector),
          job_title: this.get_job_title(found_order_job_by_job_title.rel_order_position.job_title),
          locations: [],
          location_specs: []
        }
        position.job_title.sector_name = found_order_job_by_job_title.rel_order_position.sector
        position.job_title.sector = this.get_sector(found_order_job_by_job_title.rel_order_position.sector)
        // loop through selected locations (i = 1 to ignore empty object in first position in array)
        // - add short site names to locations array in position
        for (let i = 1; i < this.found_locations.site.length; i++) {
          position.locations.push(this.found_locations.site[i].short_site_name)
          // working week array values
          let working_week = []
          this.set_working_week(working_week, found_order_job_by_job_title.rel_order_position_shift)

          // Rates
          let rates = [{}]
          for (let k = 0; k < this.new_rates[job_title].length; k++) {
            let rate_array = this.new_rates[job_title][k].split('_');
            rates.push({
              type: this.get_rate_type(rate_array[1]),
              pay_type: this.get_pay_type(rate_array[2]),
              pay_amount: rate_array[0],
              admin_fee_type: this.get_fee_type(rate_array[3]),
              admin_fee: rate_array[4],
              retention_percentage: rate_array[5],
            })
          }

          // calculate total_hours
          let start = this.$moment(found_order_job_by_job_title.rel_order_position_shift.start_time, "HH:mm"),
              end = this.$moment(found_order_job_by_job_title.rel_order_position_shift.end_time, "HH:mm"),
              lunch_duration = this.$moment.duration(found_order_job_by_job_title.rel_order_position_shift.lunch_break_length).asHours(),
              checkTotalTime = this.$moment.duration(end.diff(start)),
              totalTime

          // Negative Hours
          if (Math.sign(checkTotalTime.asHours()) === -1) {
            let negEnd = this.$moment(found_order_job_by_job_title.rel_order_position_shift.end_time, "HH:mm").add(24, 'h');
            if (!found_order_job_by_job_title.rel_order_position_shift.lunch_break_paid) {
              totalTime = this.$moment.duration(negEnd.diff(start)).asHours() - lunch_duration;
            }
            else {
              totalTime = this.$moment.duration(negEnd.diff(start)).asHours();
            }
          }
          // Positive Hours
          else if (Math.sign(checkTotalTime.asHours()) === 1) {
            if (!found_order_job_by_job_title.rel_order_position_shift.lunch_break_paid) {
              totalTime = this.$moment.duration(end.diff(start)).asHours() - lunch_duration;
            }
            else {
              totalTime = this.$moment.duration(end.diff(start)).asHours();
            }
          }
          else {
            if (!found_order_job_by_job_title.rel_order_position_shift.lunch_break_paid) {
              totalTime = 24 - lunch_duration;
            }
            else {
              totalTime = 24;
            }
          }

          // push location spec into position object
          position.location_specs.push({
            job_location_index: i - 1,
            location: this.found_locations.site[i].short_site_name,
            copy_location: null, // always null
            position_info: {
              quantity: found_order_job_by_job_title.workers_required,
              working_week: working_week,
              start_date: found_order_job_by_job_title.rel_order_position.start_date,
              start_date_disabled: {
                to: ''
              },
              end_date: found_order_job_by_job_title.rel_order_position.end_date,
              end_date_disabled: {
                to: ''
              },
              start_time: found_order_job_by_job_title.rel_order_position_shift.start_time,
              end_time: found_order_job_by_job_title.rel_order_position_shift.end_time,
              lunch_length: found_order_job_by_job_title.rel_order_position_shift.lunch_break_length,
              lunch_paid: found_order_job_by_job_title.rel_order_position_shift.lunch_break_paid,
              total_paid: found_order_job_by_job_title.rel_order_position_shift.total_hours_per_week,
              total_hours: totalTime,
              essential_qualifications: JSON.parse(found_order_job_by_job_title.rel_order_position.essential_qualifications),
              key_responsibilities: found_order_job_by_job_title.rel_order_position.key_responsibilities,
              job_brief: found_order_job_by_job_title.rel_order_position.job_brief,
              key_skills_experience: found_order_job_by_job_title.rel_order_position.key_skills_experience,
              health_and_safety: found_order_job_by_job_title.rel_order_position.health_safety_risks,
              ppe_tools: found_order_job_by_job_title.rel_order_position.ppe_tools_required,
              additional_details: found_order_job_by_job_title.rel_order_position.additional_assignment_details,
              reports_to: found_order_job_by_job_title.rel_order_position.reports_to_contact,
              number_of_rates: this.new_rates[job_title].length,
              recruitment_margin_perc: found_order_job_by_job_title.rel_order_position.recruitment_margin_perc,
              rate: rates,
              perm_details: this.set_perm_details()
            },
            show: true,
          })
        }
        // push position to position rates object
        positions_rates.position.push(position)
      })
      this.$store.commit('SAVE_POSITION_RATES_COMPLETED', positions_rates);
    },
    populate_compliance_terms(){
      

      axios.get(this.crmApiPath + 'contact/' + this.order.authorise_terms_contact_id).then(contact => {
        console.log(contact.data);

        const authDetails = contact.data;

        // Initialize the terms_business array
        const terms_business = [];

        // Loop to create the desired structure

        terms_business.push({});
        
        for (let i = 0; i < this.new_job_titles.length; i++) {
          const termObject = {
            amendments_to_terms: '',
            client_ref_po: ''
          };
          terms_business.push(termObject);
        }

        this.$store.commit('SAVE_COMPLIANCE_TERMS_COMPLETED', {
          auth_terms_contact: {
            addresses: authDetails.addresses,
            company_id: authDetails.company_id,
            created_at: authDetails.created_at,
            emails: authDetails.emails,
            id: authDetails.id,
            person: authDetails.person,
            person_id: authDetails.person_id,
            phones: authDetails.phones,
            rel_address: authDetails.rel_address,
            rel_profile: authDetails.rel_profile,
            updated_at: authDetails.updated_at,
            user: {
              contact_id: this.order.authorise_terms_contact_id
            }
          },
          ltd_reg_number: '12312312',
          moo: {
            carry_financial_risk: true,
            end_user_offer_further_work: false,
            how_work_performed: true,
            responsible_work_standard: true,
            sdc: false,
            worker_accept_further_work: false,
            worker_decline_job_movement: true,
          },
          terms_business: terms_business
        });
      })
    },
    get_sector(find_sector_value) {
      return this.$store.state.crm_options.sectors.find(s => s.sector === find_sector_value);
    },
    get_job_title(find_job_title_value) {
      return this.$store.state.crm_options.job_titles.find(jt => jt.job_title === find_job_title_value)
    },
    set_perm_details() {
      return {
        bonus: false,
        bonus_how_calculated: "",
        bonus_when_paid: "",
        bonus_amount_per_annum: "",
        bonus_included_in_charge: false,
        car_allowance: false,
        car_allowance_make_model: "",
        car_allowance_amount_per_annum: "",
        car_allowance_included_in_charge: false,
        pension_contribution_above_standard: false,
        pension_percentage: "__vue_devtool_undefined__",
        pension_included_in_charge: false,
        health_care: false,
        health_care_type: null,
        health_care_amount_per_annum: "",
        health_care_included_in_charge: false,
        any_other_benefits: false,
        any_other_benefits_description: "",
        any_other_benefits_amount_per_annum: "",
        any_other_benefits_included_in_charge: false,
        salary_range_start: "",
        salary_range_end: ""
      }
    },
    set_working_week(working_week_array, found_shift) {
      if (found_shift.work_monday) {
        working_week_array.push('work_monday')
      }
      if (found_shift.work_tuesday) {
        working_week_array.push('work_tuesday')
      }
      if (found_shift.work_wednesday) {
        working_week_array.push('work_wednesday')
      }
      if (found_shift.work_thursday) {
        working_week_array.push('work_thursday')
      }
      if (found_shift.work_friday) {
        working_week_array.push('work_friday')
      }
      if (found_shift.work_saturday) {
        working_week_array.push('work_saturday')
      }
      if (found_shift.work_sunday) {
        working_week_array.push('work_sunday')
      }
      if (found_shift.work_bank_holidays) {
        working_week_array.push('work_bank_holidays')
      }
    },
    get_rate_type(value) {
      return this.$store.state.crm_options.rate_type.find(rt => rt.value === value)
    },
    get_pay_type(value) {
      return this.$store.state.crm_options.pay_type.find(pt => pt.value === value)
    },
    get_fee_type(value) {
      return this.$store.state.crm_options.fee_type.find(ft => ft.value === value.replace('-', ' '))
    },
    /**
     * Timesheet Authorisation and accounts to store
     */
    populate_timesheet_auth_and_accounts() {
      axios.get(this.crmApiPath + 'timesheet_authorisation/client/get/' + this.order.company_id).then(ts_auth => {

        let timesheet_accounts = {
          invoice_address: this.order.invoice_address,
          days_to_pay_from_invoice: this.order.days_to_pay_from_invoice,
          accounts_contact: this.order.accounts_contact,
          ts_submission_auth_type: 'Default',
          timesheet_auth: [{}],
        }
        let sub_ts = [], auth_ts = [];
        for (let i = 0; i < ts_auth.data.length; i++) {
          if (ts_auth.data[i].submission_level >= 8) {
            ts_auth.data[i].contact.submission_level = ts_auth.data[i].submission_level;
            sub_ts.push(ts_auth.data[i].contact);
          }
          if (ts_auth.data[i].submission_level < 8) {
            ts_auth.data[i].contact.submission_level = ts_auth.data[i].submission_level;
            auth_ts.push(ts_auth.data[i].contact);
          }
        }
        timesheet_accounts.timesheet_auth.push({
          submit_ts: sub_ts,
          auth_ts: auth_ts
        });

        if (this.show_copy_job_titles_rates) {
          this.$store.commit('SAVE_TIMESHEET_AUTHORISATIONS_COMPLETED', timesheet_accounts);
        }
        else {
          this.$store.commit('COPY_ORDER_NO_POSITIONS_TIMESHEET_AUTHORISATIONS_COMPLETED', timesheet_accounts);
        }

      })
    },
    /**
     * Compliance terms to store
     */
    //populate_compliance_terms() {
      // let compliance_terms = {
      // moo: {
      //   sdc: false,
      //       worker_decline_job_movement: true,
      //       end_user_offer_further_work: false,
      //       worker_accept_further_work: false,
      //       how_work_performed: true,
      //       responsible_work_standard: true,
      //       carry_financial_risk: true,
      // },
      // drce: [{}],
      //     auth_terms_contact: null,
      //
      //     terms_business: [{}],
      //     ltd_reg_number: '12312312',
      // }
      // this.$store.commit('SAVE_COMPLIANCE_TERMS_COMPLETED', this.compliance_terms);
    //},

  },
  watch: {
    /**
     * When a job title is select for copy, retrieve rates that exist for the job title associated with the order being copied
     *
     * @param job_titles (array of job titles as strings)
     */
    'new_job_titles'(job_titles) {
      if (job_titles.length > 0) {
        axios.get(this.crmApiPath + 'order/whole_order/rates', {
          params: {
            'order_job_ids': this.order_job_ids,
            'job_titles': job_titles
          }
        }).then(rates => {
          this.order_rates = rates.data
          // remove key and values from new_rates if key not in selected job titles
          Object.keys(this.new_rates).forEach(job_title => {
            if (!(job_titles.includes(job_title))) {
              delete this.new_rates[job_title]
            }
          })
          // loop through rates returned, if key not in new_rates then add
          Object.keys(rates.data).forEach(job_title => {
            if (!(job_title in this.new_rates)) {
              // have to do it this way so dynamically created property is able to be watched for change
              this.$set(this.new_rates, job_title, [])
            }
          })
        });
      }
      else {
        // reset rates if there are no job titles selected
        this.order_rates = []
        this.new_rates = {}
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "resources/sass/mixins/box_shadow";

.geniusCard {
  padding: 10px;
  @include box_shadow_style_2;

  /* PRETTY CHECKBOX MULTI LINE */
  .pretty {
    white-space: inherit;
    margin-top:  1em;
    display:     inline-block;
    height:      auto;

    .state {
      label {
        text-indent:  0;
        padding-left: 2rem;
        line-height:  1.2;

        &:after, &:before {
          top: 0;
        }
      }
    }

    &.p-icon {
      .state {
        .icon {
          top:  3px;
          left: 2px;
        }
      }
    }
  }

  .rate_label, .rate_field {
    display:        inline-block;
    vertical-align: top;
  }

  .rate_label {
    min-width: 75px;
  }
}
</style>
